import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_151_3767)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M24.2868 4.49726L9.53148 22.2037L1.31641 13.7539L4.18439 10.9656L9.30265 16.2301L21.214 1.93652L24.2868 4.49726Z",
			fill: "#395566"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_151_3767",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.75 0.216797)"
		})
	}) })]
});
export default SvgFill;
